export default __webpack_public_path__ + "static/media/item-2.7b73b7ee.png";